module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue2.b5286a82.jpg";